// export const API_URL = 'http://localhost:3000'
export const API_URL = 'https://c1yk58m6oi.execute-api.eu-west-1.amazonaws.com/prod'
export const SERVER_ERROR = 'Error connecting to the server, please try again.'
export const VERSION = '1.0.0'



// WEBPACK FOOTER //
// ./src/settings.js